import React, {useState} from "react"
import * as PropTypes from "prop-types";
import styled from "styled-components"

import LogoShort from "../../../static/svg/logo-short.svg";
import {InternalLink} from "../../style/itf-styled-components";
import Burger from '../../../static/svg/icons/burger.svg';
import MobileMenu from "../menu/mobile-menu";
import {useMenu} from "../../data/hooks/menu";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 20px;
  width: 100%;
  background-color: ${props => props.theme.colors.neutrals._000};
`;

const HeaderLogo = styled(InternalLink)`
`;
const Logo = styled(LogoShort)`
  fill: ${props => props.theme.colors.secondary.base};
  height: 32px;
`;

const BurgerIcon = styled(Burger)`
  fill: ${props => props.theme.colors.neutrals.textDefault};
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

const Menu = styled(MobileMenu)``;

const MobileHeader = ({className, page}) => {
    const [showMenu, setShowMenu] = useState(false);
    const menu = useMenu();

    const toggleMenu = () => {
        setShowMenu(!showMenu);
    };

    return (
        <Container className={className}>
            <HeaderLogo to="/">
                <Logo/>
            </HeaderLogo>
            <div
                css={`
                  color: ${props => props.theme.colors.neutrals.textDefault};
                  font-weight: 700;
                `}
            >
                {(menu.find(i => i.page === page) || {}).label}
            </div>
            {
                showMenu
                    ? <button
                        css={`
                          cursor: pointer;
                          font-size: 24px;
                        `}
                        onClick={toggleMenu}
                    >x</button>
                    : <BurgerIcon onClick={toggleMenu}/>
            }
            {showMenu && <Menu page={page}/>}
        </Container>
    );
};

MobileHeader.propTypes = {
    page: PropTypes.string.isRequired
};

export default MobileHeader
